import React, { useState } from "react";
import Modal from "react-responsive-modal";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "../../../../../utils/yupResolver";
import backend from "../../../../../api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import useFormState from "../../../../../utils/useFormState";

const getValidationSchema = (withdrawable) =>
  yup.object().shape({
    amount: yup
      .number()
      .typeError("Amount must be a number")
      .required("Amount is required")
      .positive("Amount must be greater than 0")
      .max(withdrawable, `Amount cannot exceed ${withdrawable}`),
    payment_receiving_type: yup.string().required("Payment type is required"),
  });

const RequestWithdrawal = ({ withdrawable, getEarning }) => {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleClose = () => {
    setOpen(false);
    reset();
  };
  const { user } = useSelector((state) => state.auth);

  const { register, handleSubmit, errors, reset } = useForm({
    resolver: yupResolver(getValidationSchema(withdrawable)),
  });

  const {
    formValues,
    handleChange,
    isButtonDisabled,
    setFormValues,
  } = useFormState({
    amount: "",
    payment_receiving_type: "",
  });

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    data.requested = true;
    data.requested_date = new Date();
    data.user = user?.user?._id;
    console.log("data: ", data);
    try {
      const response = await backend.post(`/userwallet/debit-amount`, data);
      if (response) {
        toast.success("Request Submitted Successfully");
        getEarning();
        handleClose();
      }
    } catch (error) {
      console.error("error: ", error);
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <button className="btn btn-solid" onClick={() => setOpen(true)}>
        Request Withdrawal
      </button>
      <Modal open={open} onClose={handleClose} center>
        <div className="container px-5 pt-5 custom-modal">
          <div className="row">
            <div className="col-12">
              <h2>Request Withdrawal</h2>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <label htmlFor="amount">Amount to Withdraw</label>
                  <input
                    type="number"
                    id="amount"
                    name="amount"
                    step="0.01"
                    value={formValues.amount}
                    onChange={handleChange}
                    ref={register()}
                    className={`form-control ${
                      errors.amount ? "is-invalid" : ""
                    }`}
                    placeholder="Enter amount"
                  />
                  {errors.amount && (
                    <div className="invalid-feedback">
                      {errors.amount.message}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="payment_receiving_type">
                    Payment Receiving Type
                  </label>
                  <select
                    id="payment_receiving_type"
                    name="payment_receiving_type"
                    value={formValues.payment_receiving_type}
                    onChange={handleChange}
                    ref={register()}
                    className={`form-control ${
                      errors.payment_receiving_type ? "is-invalid" : ""
                    }`}
                  >
                    <option value="">Select payment type</option>
                    <option value="E-money">E-money</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Gift Card">Gift Card</option>
                  </select>
                  {errors.payment_receiving_type && (
                    <div className="invalid-feedback">
                      {errors.payment_receiving_type.message}
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  className="btn btn-solid ml-auto"
                  disabled={isSubmitting || isButtonDisabled}
                >
                  {isSubmitting ? "Submitting..." : "Submit Request"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RequestWithdrawal;
